import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle, Typography
} from "@mui/material"
import PaperDraggable from "../../../../../../components/PaperDraggable"
import axiosClient from "../../../../../../lib/axios"
import { useMutation, useQueryClient } from "react-query";
import { enqueueSnackbar } from "notistack";
import LoadingApiQuery from "../../../../../../components/LoadingApiQuery";

export default function DialogTransferencia({
    loja_id,
    handleClose,
    expedicao_id,
    status
}: DialogGerarTransferenciaProps) {
    const queryClient = useQueryClient();

    const {
        mutate: gerarTransferencia, isLoading: isGerandoTransferencia
    } = useMutation({
        mutationKey: 'gerar-transferencia',
        mutationFn: (inputs: { expedicao_id: number | null }) =>
            axiosClient.post("/estoque/expedicao/gerar-transferencia/", inputs),
        onError: () => {
            enqueueSnackbar("Erro ao gerar transferência", { variant: "error" });
        },
        onSuccess: () => {
            enqueueSnackbar("Transferência criada com sucesso", { variant: "success" });
            queryClient.invalidateQueries('pesquisar-expedicoes');
            handleClose();
        }
    });


    const handleGerarTransferenciaClick = () => {
        gerarTransferencia({ expedicao_id });
    };

    const {
        mutate: excluirTransferencia, isLoading: isExcluindoTransferencia
    } = useMutation({
        mutationKey: 'excluir-transferencia',
        mutationFn: () =>
            axiosClient.delete(`/estoque/expedicao/excluir-transferencia/${expedicao_id}`),
        onError: () => {
            enqueueSnackbar("Erro ao excluir transferência", { variant: "error" });
        },
        onSuccess: () => {
            enqueueSnackbar("Transferência excluída com sucesso", { variant: "success" });
            queryClient.invalidateQueries('pesquisar-expedicoes');
            handleClose();
        }
    });


    const handleExcluirTransferenciaClick = () => {
        excluirTransferencia();
    };

    return (
        <>
            <Dialog
                open={Boolean(loja_id)}
                onClose={handleClose}
                fullWidth
                maxWidth="sm"
                PaperComponent={PaperDraggable}
                aria-labelledby="draggable-dialog-title"
            >
                {status === "Concluída" && (
                    <>
                        <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
                            Gerar transferência
                        </DialogTitle>

                        <DialogContent>
                            <Typography variant="subtitle1">
                                Gostaria de gerar transferência para o pedido selecionado?
                            </Typography>
                        </DialogContent>

                        {isExcluindoTransferencia && <LoadingApiQuery />}

                        <DialogActions>
                            <Button variant="outlined"
                                onClick={handleClose}
                            >
                                Fechar
                            </Button>
                            <Button
                                color="success"
                                variant="contained"
                                onClick={handleGerarTransferenciaClick}
                                disabled={isGerandoTransferencia}
                            >
                                {isGerandoTransferencia ? "Gerando..." : "Gerar"}
                            </Button>

                        </DialogActions>
                    </>
                )}
                {status === "Transferido" && (
                    <>
                        <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
                            Excluir transferência
                        </DialogTitle>


                        <DialogActions style={{ justifyContent: "center" }}>
                            <Typography variant="subtitle1" align="center">
                                Gostaria de excluir transferência para o pedido selecionado?
                            </Typography>
                        </DialogActions>

                        {isExcluindoTransferencia && <LoadingApiQuery />}

                        <DialogActions>
                            <Button variant="outlined"
                                onClick={handleClose}
                                disabled={isExcluindoTransferencia}
                            >
                                Fechar
                            </Button>
                            <Button
                                color="error"
                                variant="contained"
                                onClick={handleExcluirTransferenciaClick}
                                disabled={isExcluindoTransferencia} // Desabilita o botão durante o carregamento
                            >
                                {isExcluindoTransferencia ? "Excluindo..." : "Excluir Transferência"}
                            </Button>

                        </DialogActions>
                    </>
                )}
            </Dialog>
        </>
    )
}

interface DialogGerarTransferenciaProps {
    loja_id: number,
    handleClose: () => void,
    status: string,
    expedicao_id: number | null
}